import React, { FunctionComponent, useContext } from "react";
import styles from "./ErrorMessage.module.scss";
import { GitHub } from "@material-ui/icons";
import useLogin from "shared/utils/useLogin";
import AppContext from "context/AppContext";
import { Errors } from "shared/types/errors";
import RefreshingBeverage from "./RefreshingBeverage";
import Button from "../Buttons/Button";
import { useHistory } from "react-router-dom";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const ErrorMessage: FunctionComponent<{
  errorType?: string;
  close?: () => void;
}> = ({ errorType, close }) => {
  const { state, dispatch } = useContext(AppContext);

  const { loginWithGithub } = useLogin({ dispatch });
  const history = useHistory();

  if (
    errorType === Errors.requireLogin ||
    state.error === Errors.requireLogin
  ) {
    return (
      <div className={styles.errorMessage}>
        <>
          <RefreshingBeverage />
          <h4>Login Required</h4>

          <div className={styles.errorMessage_content}>
            <p>The action requires you to be logged in.</p>
            <p>Sign in to continue.</p>

            <button
              className={styles.errorMessage_loginButton}
              onClick={loginWithGithub}
              aria-label="Login with github"
            >
              <span>Login with Github</span> <GitHub fontSize="inherit" />
            </button>
          </div>
        </>
      </div>
    );
  }

  if (errorType === Errors.reputationsDeclined) {
    return (
      <div className={styles.errorMessage}>
        <RefreshingBeverage />
        <h4>You don't have enough reputations!</h4>

        <div className={styles.errorMessage_content}>
          <p>
            You can only start 5 projects at the same time. Please try again
            later
          </p>
        </div>

        <div className={styles.errorMessage_buttonRow}>
          <Button
            onClick={() => window.location.reload()}
            textTransform="capitalize"
            aria-label="Reload"
          >
            Reload
          </Button>

          <div style={{ marginLeft: "var(--space-sm)" }}>
            <Button
              buttonVariant="default"
              textTransform="capitalize"
              aria-label="Homepage"
              onClick={() => {
                if (close) {
                  close();
                }

                history.push("/");
              }}
            >
              Homepage
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.errorMessage}>
      {state.error === Errors.sessionExpired && (
        <>
          <RefreshingBeverage />
          <h4>Session has expired</h4>

          <div className={styles.errorMessage_content}>
            <p>Please sign in again to continue.</p>

            <button
              className={styles.errorMessage_loginButton}
              onClick={loginWithGithub}
              aria-label="Login with github"
            >
              <span>Login with Github</span> <GitHub fontSize="inherit" />
            </button>
            <FormControlLabel
              control={<Checkbox name="gilad" />}
              label="Gilad Gray"
            />
          </div>
        </>
      )}

      {state.error === Errors.unexpectedError && (
        <>
          <RefreshingBeverage />
          <h4>Unexpected Error Happens!</h4>

          <div className={styles.errorMessage_content}>
            <p>Please try again.</p>
          </div>

          <div className={styles.errorMessage_buttonRow}>
            <Button
              onClick={() => window.location.reload()}
              textTransform="capitalize"
              aria-label="Reload"
            >
              Reload
            </Button>

            <div style={{ marginLeft: "var(--space-sm)" }}>
              <Button
                buttonVariant="default"
                textTransform="capitalize"
                aria-label="Homepage"
                onClick={() => {
                  if (close) {
                    close();
                  }

                  history.push("/");
                }}
              >
                Homepage
              </Button>
            </div>
          </div>
        </>
      )}

      {errorType === Errors.endorsementExisted && (
        <>
          <RefreshingBeverage />
          <h4>You already endorsed this user with this skill</h4>

          <div className={styles.errorMessage_content}>
            <p>Endorse them for other skills by visiting their profile</p>
          </div>

          <div className={styles.errorMessage_buttonRow}>
            <div style={{ marginLeft: "var(--space-sm)" }}>
              <Button
                buttonVariant="primary"
                textTransform="capitalize"
                aria-label="Homepage"
                onClick={close}
              >
                Okay
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ErrorMessage;
